function copyObject(obj) {
  /**
   * Use to deep copy a Javascript object or array
   * @param obj A JS object, { ... } or array, [ ... ]
   */
  return JSON.parse(JSON.stringify(obj));
}

export default copyObject;
